<div class="pdf-container" *ngIf="pdfFile && form && isLoaded">
    <ngx-extended-pdf-viewer [src]="pdfFile"
    useBrowserLocale="true"
    [showToolbar]="false"
    [showSidebarButton]="false"
    [showDownloadButton]="false"
    [showPrintButton]="false"
    [showOpenFileButton]="false"
    [showSecondaryToolbarButton]="false"
    [enablePrint]="false"
    [height]="viewport.isMobileView() ? '80vh' : '90vh'"
    [minZoom]="minZoom" 
    [maxZoom]="maxZoom"
    [zoom]="zoom"
    (zoomChange)="onZoomChange($event)"
    (pagesLoaded)="attachFormFieldListeners($event)" 
    (pageRendered)="onPageRendered($event)">
    </ngx-extended-pdf-viewer>
</div>